import React from 'react';
import Terminal from '../components/Terminal';
import Navigation from '../components/Navigation';
import Particles from '../components/Particles';
import Footer from '../components/Footer';
import { Button } from '../design-system';
import { createPopup } from '@typeform/embed';
import '@typeform/embed/build/css/popup.css';

const Home: React.FC = () => {
  const togglePopup = () => {
    const { toggle } = createPopup('QXs6zOPX');
    toggle();
  };

  return (
    <div className="relative min-h-screen bg-dark-900">
      <Particles />
      <Navigation noBorder={true} />
      {/* Hero Section - Mobile Optimized */}
      <div className="flex items-center justify-center min-h-screen px-4 pb-8 pt-14 md:pt-24 lg:pt-16">
        <div className="w-full px-4 mx-auto max-w-7xl sm:px-6 lg:px-8 xl:px-12">
          <div className="grid items-center gap-8 lg:grid-cols-2 lg:gap-12">
            {/* Right Content - Terminal (Image/CLI) comes first on mobile */}
            <div className="flex justify-center order-1 lg:justify-end lg:order-2">
              <div className="w-full max-w-xs transform scale-90 sm:max-w-sm sm:scale-100 lg:max-w-none lg:scale-100">
                <Terminal />
              </div>
            </div>
            {/* Left Content (Text) comes second on mobile */}
            <div className="order-2 space-y-4 text-center lg:text-left lg:order-1 md:space-y-6">
              <h1 className="text-2xl font-bold leading-tight text-white sm:text-3xl md:text-4xl lg:text-5xl">{/* continue */}
                Get up and running with AI innovation
              </h1>
              <p className="text-sm leading-relaxed sm:text-base md:text-lg lg:text-xl text-white/80">
                Run cutting-edge AI for 3D simulation, media, and code generation for all your business needs.<br />
                <span className="block mt-2 text-base font-semibold sm:text-lg md:text-xl lg:text-2xl text-primary-400">
                  Infinite possibilities, on the way.
                </span>
              </p>
              <div className="space-y-3">
                <div>
                  <Button
                    as="button"
                    onClick={togglePopup}
                    size="lg"
                  >
                    Join Waitlist
                  </Button>
                </div>
                <p className="text-xs sm:text-sm md:text-base text-white/60">
                  Available soon for MacOS, Linux, & Windows
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer noBorder={true} fixedOnDesktop={true} />
    </div>
  );
};

export default Home;
